'use client'

import * as React from 'react'
import { useSortBy } from 'react-instantsearch'
import { useTranslations } from 'next-intl'
import { Select } from '@repo/web-ui/components/select/select'

import { SORTING_OPTIONS } from '../constants'

export function SearchResultsSort() {
  const t = useTranslations('pages.search')
  const { refine, currentRefinement } = useSortBy({ items: SORTING_OPTIONS })

  const handleSort = (value: string) => {
    refine(value)
  }

  return (
    <Select
      wrapLabels
      value={currentRefinement}
      onValueChange={handleSort}
      items={SORTING_OPTIONS.map(option => ({ ...option, label: t(option.label) }))}
    />
  )
}
